export const detailUrl = ({ id }) =>
  `/parking-contracts/detail/${id}/invoicing`;

export const invoicingToContractDetailUrl = ({ id }) =>
  `/error-redirect/invoicingparking/${id}`;
